import { Injectable, OnDestroy } from '@angular/core';
import { deepCopy } from '@common/helpers';
import { updateStateServiceRequestPaymentInput } from '@common/store/service-request-payment-input/service-request-payment-input.actions';
import { serviceRequestPaymentInputInitialState } from '@common/store/service-request-payment-input/service-request-payment-input.reducer';
import { getDataServiceRequestPaymentInput } from '@common/store/service-request-payment-input/service-request-payment-input.selector';
import { ServiceRequestPaymentInputState } from '@common/store/service-request-payment-input/service-request-payment-input.state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServiceRequestPaymentInputStoreService implements OnDestroy {
  private _storeCurrentValueSubscription$!: Subscription;
  private _storeCurrentValue = serviceRequestPaymentInputInitialState;

  constructor(private store: Store) {
    this._storeCurrentValueSubscription$ = this.store.select(getDataServiceRequestPaymentInput).subscribe((val) => {
      this._storeCurrentValue = val ?? serviceRequestPaymentInputInitialState;
    });
  }

  get storeCurrentValue() {
    return this._storeCurrentValue;
  }

  updateServiceRequestPaymentInput(value: ServiceRequestPaymentInputState) {
    this.store.dispatch(updateStateServiceRequestPaymentInput({ ...deepCopy(this._storeCurrentValue), ...value }));
  }

  ngOnDestroy() {
    this._storeCurrentValueSubscription$.unsubscribe();
  }
}
